import {useEffect, useRef, useState} from 'react';
import {useCommand} from '@synako/haligator';
import {Resource, State} from '@synako/halitrek';
import {
  RootDesc as FFConnectRoot,
  PanierValideEventDesc,
} from 'api-types/ffconnect-hal';

export type Paiement1p6PageState = 'loading' | 'error';

export const PAIEMENT_1P6_ERROR_REDIRECT_DELAY_MS = 4000;

export const usePaiement1p6Traitement = ({
  api,
  panier_id,
  onSuccess,
}: {
  api: Resource<FFConnectRoot>;
  panier_id: string | null;
  onSuccess: (event: State<PanierValideEventDesc>) => void;
}): {pageState: Paiement1p6PageState} => {
  const [pageState, setPageState] = useState<Paiement1p6PageState>('loading');
  const lastSubmittedPanierIdRef = useRef<string | null>(null);

  const panierNav = panier_id
    ? api.follow('get-panier', {panier_id})
    : undefined;
  const paiementOptionNav = panierNav?.follow('paiement_option');

  const traiterPaiement = useCommand(
    paiementOptionNav,
    'c:traiter-paiement',
    {},
  );

  useEffect(() => {
    if (!panier_id) {
      setPageState('error');
      return;
    }
    if (lastSubmittedPanierIdRef.current === panier_id) return;
    lastSubmittedPanierIdRef.current = panier_id;
    paiementOptionNav?.clearCache();
    traiterPaiement
      .submitAsync({})
      .then(onSuccess)
      .catch(() => {
        setPageState('error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panier_id]);

  return {pageState};
};
